import { createStyles } from '@mantine/core';

const useStyles = createStyles((theme) => ({
  hidden: {
    display: 'none',
  },
  container: {
    display: 'flex',
    flexFlow: 'column nowrap',
    alignItems: 'center',
    justifyContent: 'center',
    maxWidth: '100%',
    minHeight: '100%',
    gap: theme.other.spacing._24,
    padding: /* eslint-disable-line local-rules/use-theme-tokens */ '76px 16px',
    backgroundColor: theme.white,
  },
  forgotPasswordContainer: {
    maxWidth: 420,
    display: 'flex',
    flexFlow: 'column nowrap',
    alignItems: 'center',
    justifyContent: 'center',
    gap: theme.other.spacing._24,
  },
  forgotPasswordHeader: {
    display: 'flex',
    flexFlow: 'column nowrap',
    alignItems: 'center',
    justifyContent: 'center',
    gap: theme.other.spacing._8,
  },
  resetPassword: {
    maxWidth: 420,
    gap: theme.other.spacing._12,
    display: 'flex',
    flexFlow: 'column nowrap',
    alignItems: 'center',
    justifyContent: 'center',
  },
  emailInput: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex',
    input: {
      backgroundColor: theme.colors.gray[1],
      '&:disabled': {
        backgroundColor: 'rgba(241, 243, 245, 0.5)',
        textAlign: 'center',
        color: theme.colors.gray2[6],
        opacity: 1,
      },
    },
  },
  emailLink: {
    fontWeight: 600,
  },
  titleContainer: {
    display: 'flex',
    textAlign: 'center',
  },
  formContainer: {
    display: 'flex',
    flexFlow: 'column nowrap',
    alignItems: 'center',
    gap: theme.other.spacing._24,
    width: '100%',
    maxWidth: '420px',
  },
  headerContainer: {
    display: 'flex',
    alignItems: 'center',
    textAlign: 'center',
    gap: theme.other.spacing._8,
  },
  titleChildContainer: {
    gap: theme.other.spacing._6,
  },
  passwordManagerContainer: {
    display: 'flex',
    alignItems: 'center',
    alignSelf: 'middle',
    gap: theme.other.spacing._24,
  },
  managerCopy: {
    maxWidth: 420,
  },

  passwordForm: {
    gap: theme.other.spacing._16,
  },
  resetPasswordSuccessContainer: {
    maxWidth: 360,
    gap: theme.other.spacing._12,
    display: 'flex',
    flexFlow: 'column nowrap',
    alignItems: 'center',
    justifyContent: 'center',
  },
}));

export default useStyles;
